import { useSelector } from 'react-redux';
import Input from 'components/Input';
import { useTranslateByProject } from 'hooks/translation-hooks';
import { regexSelectors } from 'redux/selectors/config';
import { ga4Event } from 'analytics';

const PlateNumber = ({ register, errors, label, placeholder }) => {
  const t = useTranslateByProject();
  const plateNumberPattern = useSelector(regexSelectors)?.plate_number;
  const name = 'registration_number';

  const handleFocus = () => {
    ga4Event({
      eventaction: 'click_field',
      payload: {
        form_name: 'request assistance',
        field_name: 'plate number',
      },
    });
  };

  return (
    <Input
      {...register(name, {
        required: true,
        pattern: new RegExp(
          plateNumberPattern?.regex,
          plateNumberPattern?.flag || 'i',
        ),
      })}
      textTransform="uppercase"
      error={errors[name] && 'plate_number_error_format'}
      label={t(label || 'plate_number')}
      placeholder={t(placeholder || 'plate_number-placeholder')}
      testId="plate_number"
      onFocus={handleFocus}
    />
  );
};

export default PlateNumber;
